<template>
  <router-view />
</template>
<style>
      body{
      overflow-y: auto;
      }
  
      /* Scrollbar entière */
      body:-webkit-scrollbar {
      width: 8px;
      }
  
      /* Fond de la scrollbar */
      body:-webkit-scrollbar-track {
          background: #f0f0f0;   /* Couleur de fond */
          border-radius: 8px;
      }
  
      /* Curseur (thumb) */
      body:-webkit-scrollbar-thumb {
      background-color: #F5EFE0;  /* Couleur de la barre */
      border-radius: 8px;
      border: 2px solid #f0f0f0; /* Crée un effet de marge */
      }
  
      /* Hover du curseur */
      body:-webkit-scrollbar-thumb:hover {
          background-color: #F5EFE0;
      }
      body{
          scrollbar-width: thin;
          scrollbar-color: #F5EFE0 #f0f0f0; /* thumb color | track color */
        }
  
    </style>